import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import { PlaceholderButton } from ".";

import styles from "./TitledContainer.css";

export default class TitledContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };

    this.handleEdit = this.handleEdit.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleEdit() {
    if (this.props.onEdit) this.props.onEdit();
  }

  handleMouseEnter() {
    this.setState({ isHovered: true });
  }

  handleMouseLeave() {
    this.setState({ isHovered: false });
  }

  render() {
    const { infoComponent, isEdit, isEditable, isEmpty, isLarge, title } = this.props;
    const { isHovered } = this.state;

    const showPlaceholder = isEditable && !isEdit && isEmpty && isHovered;
    const children = isEmpty && !isEdit ? "-" : this.props.children;

    const content = showPlaceholder ? (
      <PlaceholderButton onClick={this.handleEdit} text={title} />
    ) : (
      children
    );

    return (
      <div className={styles.root}>
        {title && (
          <div className={classnames(styles.title, { [styles.large]: isLarge })}>
            <label>{title}</label>
            {infoComponent}
          </div>
        )}
        <div
          className={styles.content}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {content}
        </div>
      </div>
    );
  }
}

TitledContainer.propTypes = {
  infoComponent: PropTypes.node,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  isEditable: PropTypes.bool,
  isEdit: PropTypes.bool,
  isEmpty: PropTypes.bool,
  isLarge: PropTypes.bool,
  onEdit: PropTypes.func,
};
